import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api_endpoints from "utils/backendroutes";

// Example async login thunk
export const adminLoginUser = createAsyncThunk(
  "adminLogin/adminLoginUser",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await fetch(api_endpoints.adminLogin, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue({message:data.message ||"Login failed"});
      }
      return data; 
    } catch (error) {
      return rejectWithValue({message:error.message || "Network error"});
    }
  }
);

const adminLoginSlice = createSlice({
  name: "adminLogin",
  initialState: {
    user: null,
    token: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout(state) {
      state.user = null;
      state.token = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminLoginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminLoginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(adminLoginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Login failed";
      });
  },
});

export const {adminLogout} = adminLoginSlice.actions;

export default adminLoginSlice;
